if (!customElements.get('hh-offer-picker')) {
  class HHOfferPicker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.root = document.getElementById('ProductInfo-' + this.dataset.section) || this.closest('.product__info-container');
      if (!this.root) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-pixie-variants]').textContent);
      this.selection = [{style:'Dewdrop',size:'XS'},{style:'Twilight',size:'XS'},{style:'Moonshadow',size:'XS'}];
      this.root.classList.add('hh-has-offers');
      this.dataset.ready = 'true';
      this.syncPreferences();
      this.changeHandler = event => {
        if (event.target.matches('input[type="radio"]')) this.paint(event.target.dataset.count);
        if (event.target.matches('[data-pixie-style],[data-pixie-size]')) {
          const row = event.target.closest('[data-pair]');
          this.selection[Number(row.dataset.pair)] = {style:row.querySelector('[data-pixie-style]').value,size:row.querySelector('[data-pixie-size]').value};
          this.syncSelections();
          this.updateForm();
        }
        for (const [selector,key] of [['[data-hh-protection]','protection'],['[data-hh-mystery-gift]','gift']]) {
          if (event.target.matches(selector)) {
            this.querySelectorAll(selector).forEach(input => { input.checked = event.target.checked; });
            try { sessionStorage.setItem('pixie-'+key,String(event.target.checked)); } catch {}
          }
        }
      };
      this.addEventListener('change',this.changeHandler);
      this.paint(1);
    }
    syncPreferences() {
      for (const [selector,key] of [['[data-hh-protection]','protection'],['[data-hh-mystery-gift]','gift']]) {
        try { const saved=sessionStorage.getItem('pixie-'+key); if(saved!==null)this.querySelectorAll(selector).forEach(input=>{input.checked=saved==='true';}); } catch {}
      }
    }
    syncSelections() {
      this.querySelectorAll('[data-pair]').forEach(row => {
        const value = this.selection[Number(row.dataset.pair)];
        row.querySelector('[data-pixie-style]').value=value.style;
        row.querySelector('[data-pixie-size]').value=value.size;
        const variant=this.variants.find(v=>v.option1===value.style);
        const image=row.querySelector('img');
        if(image&&variant?.featured_image?.src){image.src=variant.featured_image.src;image.removeAttribute('srcset');image.alt=value.style;}
      });
    }
    updateForm() {
      const value=this.selection[0];
      const offer=['Solo Pixie','Pixie Duo','Pixie Trio'][this.count-1];
      const variant=this.variants.find(v=>v.option1===value.style&&v.option2===value.size&&v.option3===offer);
      if(variant)this.root.querySelectorAll('product-form input[name="id"]').forEach(input=>{input.value=variant.id;});
    }
    paint(count) {
      this.count=Number(count);
      const selected=this.querySelector('.hh-offer-card[data-count="'+this.count+'"]');
      if(!selected)return;
      this.querySelectorAll('.hh-offer-card').forEach(card=>{card.dataset.active=String(card===selected);});
      this.querySelectorAll('input[type="radio"]').forEach(input=>{input.checked=Number(input.dataset.count)===this.count;});
      for(const [selector,value] of [['[data-hh-selected-price]',selected.dataset.offerPrice],['[data-hh-selected-compare]',selected.dataset.offerCompare],['[data-hh-selected-saving]','SAVE '+selected.dataset.offerSaving+'%']]){
        const element=this.querySelector(selector);if(element)element.textContent=value;
      }
      this.syncSelections();this.updateForm();
    }
    getSelections(){return this.selection.slice(0,this.count);}
    disconnectedCallback(){this.removeEventListener('change',this.changeHandler);this.ready=false;}
  }
  customElements.define('hh-offer-picker',HHOfferPicker);
}
